"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var editable_text_option_row_component_1 = __importDefault(require("./editable-text-option-row.component"));

var use_set_action_preview_hook_1 = __importDefault(require("../action-preview/use-set-action-preview.hook"));

var EditableTextOptionRowContainer = function EditableTextOptionRowContainer(props) {
  var _use_set_action_previ = use_set_action_preview_hook_1.default(),
      setActionPreview = _use_set_action_previ.setActionPreview,
      resetActionPreview = _use_set_action_previ.resetActionPreview;

  return react_1.default.createElement(editable_text_option_row_component_1.default, Object.assign({
    handleMouseEnter: function handleMouseEnter() {
      return setActionPreview(props.option);
    },
    handleMouseLeave: function handleMouseLeave() {
      return resetActionPreview();
    }
  }, props));
};

exports.default = EditableTextOptionRowContainer;